/* istanbul ignore next */
var operator = {
    scrollToTop: function () { }
};
/* istanbul ignore next */
var getOperatorFunctions = function (operator) {
    Object.keys(operator).forEach(function (func) {
        operator[func] = window && window["whl"] && typeof window["whl"][func] === "function"
            ? window["whl"][func]
            : function () { throw new Error(func + " is missing from whl object"); };
    });
    return operator;
};
/* istanbul ignore next */
export var seamlessApi = Object.defineProperties({}, {
    operator: {
        enumerable: false,
        configurable: false,
        get: function () { return getOperatorFunctions(operator); },
        set: function (x) { throw new Error("Readonly property \"operator\" cannot be set"); }
    }
});
//# sourceMappingURL=SeamlessApi.js.map